export async function com_DecryptString(encryptedBase64, hexKey) {
  function hexToBytes(hex) {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = parseInt(hex.substr(i * 2, 2), 16);
    }
    return bytes;
  }

  function restoreBase64(str) {
    let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += "=".repeat(4 - pad);
    return base64;
  }

  let token = encryptedBase64;
 token = decodeURIComponent(token); 

  token = token.replace(/\s+/g, "");
  token = restoreBase64(token);

  const rawData = Uint8Array.from(atob(token), (c) => c.charCodeAt(0));

  const ivLength = 12;
  const tagLength = 16;

  const iv = rawData.slice(0, ivLength);
  const tag = rawData.slice(ivLength, ivLength + tagLength);
  const ciphertext = rawData.slice(ivLength + tagLength);

  const cipherWithTag = new Uint8Array(ciphertext.length + tag.length);
  cipherWithTag.set(ciphertext);
  cipherWithTag.set(tag, ciphertext.length);

  const keyBytes = hexToBytes(hexKey);
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  );

  const decryptedBuffer = await crypto.subtle.decrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    cipherWithTag
  );

  return new TextDecoder().decode(decryptedBuffer);
}

export const com_currentDateRange = (addition_days = 0) => {
  //Current Date
  const current = new Date();
  const startDate =
    current.getFullYear() +
    "-" +
    ("0" + (current.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + current.getDate()).slice(-2);

  //Last Date
  var lastDate = new Date();
  if (parseInt(addition_days) != 0) {
      lastDate.setDate(lastDate.getDate() + parseInt(addition_days));
  }

  const endDate =
    lastDate.getFullYear() +
    "-" +
    ("0" + (lastDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + lastDate.getDate()).slice(-2);

  if (endDate < startDate) {
    var dateArr = { startDate: endDate, endDate: startDate };
  } else {
    dateArr = { startDate: startDate, endDate: endDate };
  }

  return dateArr;
};

export const com_verifyAllowOrNotSetting = () => {
  return true;
};

/**
 * Check if user's subscription is expired (for both free and premium)
 * @param {Object} user - User object (can be from store or localStorage)
 * @returns {Object} - { isExpired: Boolean, subscriptionType: String } - true if subscription is expired
 */
export const com_isSubscriptionExpired = (user) => {
  try {
    // Handle different user data structures
    // Case 1: From store: user.data.data.result.subscriber
    // Case 2: From localStorage: user.subscriber (direct result object)
    const subscriber =
      user?.data?.data?.result?.subscriber ||
      user?.data?.result?.subscriber ||
      user?.subscriber;
    if (!subscriber) return { isExpired: false, subscriptionType: null };

    const subscriptionType =
      subscriber.subscription_type || subscriber.susbcription_type;
    const status = subscriber.status;
    const validityDate = subscriber.subscription_validity_date;

    if (!subscriptionType) {
      return { isExpired: false, subscriptionType: null };
    }

    const normalizedType = subscriptionType.toLowerCase();

    // For premium users, check status === "expired"
    if (normalizedType === "premium") {
      const isExpired = status?.toLowerCase() === "expired";
      return { isExpired, subscriptionType: subscriptionType };
    }

    // For free users, check if validity date is expired
    if (normalizedType === "free") {
      if (!validityDate) {
        return { isExpired: false, subscriptionType: subscriptionType };
      }

      const validUntil = new Date(validityDate);
      if (isNaN(validUntil.getTime())) {
        return { isExpired: false, subscriptionType: subscriptionType }; // invalid date
      }

      const today = new Date();
      validUntil.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const isExpired = today > validUntil;
      return { isExpired, subscriptionType: subscriptionType };
    }

    // For other subscription types, return not expired
    return { isExpired: false, subscriptionType: subscriptionType };
  } catch (error) {
    console.error("Error checking subscription:", error);
    return { isExpired: false, subscriptionType: null };
  }
};

/**
 * Check if user's subscription is expired and type is "free"
 * @param {Object} user - User object (can be from store or localStorage)
 * @returns {Boolean} - true if subscription is expired and type is free
 */
export const com_isSubscriptionExpiredAndFree = (user) => {
  const { isExpired, subscriptionType } = com_isSubscriptionExpired(user);
  return isExpired && subscriptionType?.toLowerCase() === "free";
};
